import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

type ReportModel = {
  name: string;
  title: string;
};

export default function ReportsIndex() {
  const [isLoading, setIsLoading] = useState(true);
  const [reports, setReports] = useState<ReportModel[]>([]);

  const {
    user: { organization },
    isAdmin,
  } = useAuth();

  async function getReports() {
    if (organization) {
      setIsLoading(true);
      const { data } = await api.get(
        `organizations/${organization.id}/reports`
      );
      setReports(data.data);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getReports();
  }, [organization]);

  return (
    <div>
      <header>
        <h1>Relatórios</h1>
      </header>
      <main className='mt-4'>
        {isLoading ? (
          <div className='placeholder-glow'>
            <span className='placeholder placeholder-lg col-12' />
            <span className='placeholder placeholder-xs col-12 bg-dark' />
            <span className='placeholder col-12 bg-secondary' />
            <span className='placeholder col-12 bg-secondary' />
            <span className='placeholder col-12 bg-secondary' />
          </div>
        ) : (
          <div className='list-group'>
            {reports.map((report: ReportModel) => (
              <Link
                to={report.name}
                key={report.name}
                className='list-group-item list-group-item-action'
              >
                {report.title}
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
